module.exports = __webpack_public_path__ + "static/widget-img-11-a4a774ac196f79e6c16a2a26b2f508a8.png";